import {ProductModel} from '../../modules/auth/models/UserModel'
import {useSelector} from 'react-redux'
import {RootState} from '../../../setup'
import {VerifyDateCondition} from '../functions/Token'

type Props = {
  productKey: keyof RootState['products']
  redirectPath: string
}

export const useAuthorization = ({productKey, redirectPath}: Props) => {

  const product: ProductModel = useSelector((state: RootState) => state.products[productKey]) as ProductModel
  const isAuthorized = VerifyDateCondition(product.encrypted, product.activated_at);
  const redirectTo = !isAuthorized ? '/dashboard' : redirectPath;

  return {isAuthorized, redirectTo}
}

